//export const baseUrl = "https://labgamepi.herokuapp.com";
//export const baseUrl = "https://pi-videogames-main-production.up.railway.app";
export const baseUrl = "https://main.drbzv0w3mvycv.amplifyapp.com";
